import { FormControlLabel, Grid, Typography } from '@mui/material';
import Checkbox from 'components/checkbox';
import { useFormContext } from 'react-hook-form';

const WORKING_DAYS = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];

export const WorkingDays = () => {
  const { watch, setValue } = useFormContext();

  const workingDays: number[] = watch('workingDays') || [];

  const handleChange = (day: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;

    let nextValue = checked ? [...workingDays, day] : workingDays.filter((d) => d !== day);

    nextValue = nextValue.sort((a, b) => a - b);

    setValue('workingDays', nextValue);
  };

  return (
    <>
      <Typography sx={{ mb: '8px', fontFamily: 'Inter', fontSize: '14px' }}>Work Days</Typography>

      <Grid sx={{ display: 'flex', gap: '12px', ml: '12px' }}>
        {WORKING_DAYS.map(({ value, label }) => (
          <FormControlLabel
            key={value}
            control={
              <Checkbox
                sx={{ mr: '5px' }}
                checked={workingDays.includes(value)}
                onChange={handleChange(value)}
              />
            }
            label={<Typography sx={{ fontFamily: 'Inter', fontSize: '14px' }}>{label}</Typography>}
          />
        ))}
      </Grid>
    </>
  );
};
